import type { ApiQuestion } from '../../../../internalTypes';

type SelectableScalePoint = { id: string; optionLabel: string };

export function buildSelectableScalePoints(
  question: ApiQuestion,
  language?: string,
  options?: { defaultCount?: number }
): SelectableScalePoint[] {
  const selectable = (question.answerDetails ?? []).filter(
    a => !a.hidden && !a.additional?.isHintText
  );

  if (selectable.length > 0) {
    return selectable.map((a, i) => ({
      id: a.id ?? String(i),
      optionLabel:
        (language && a.translations?.[language]?.answerText) || a.answerText || String(i),
    }));
  }

  if (options?.defaultCount !== undefined) {
    return Array.from({ length: options.defaultCount }, (_, i) => ({
      id: String(i),
      optionLabel: String(i),
    }));
  }

  return [];
}
